import React, { useState } from 'react';
import CheckboxInput from '@/components/form/CheckboxInput.tsx';
import { TourConsentPreviewDto } from '@/features/public/booking/types/TourConsentPreviewDto.ts';
import { ConsentType } from '@/features/dashboard/consentTemplates/types/ConsentTemplateType.ts';
import { UseFormRegisterReturn } from 'react-hook-form';
import ConsentPreviewModal from '@/features/public/booking/components/ConsentPreviewModal.tsx';
import { BookingSpecificationRequest } from '@/features/public/booking/types/BookingSpecificationRequest.ts';

const TourConsentCheckbox = ({
  consent,
  register,
  error,
  orgSlug,
  tourSlug,
  bookingSpecification,
}: {
  consent: TourConsentPreviewDto;
  register: UseFormRegisterReturn;
  error?: string;
  orgSlug: string;
  tourSlug: string;
  bookingSpecification: BookingSpecificationRequest;
}) => {
  const [previewOpen, setPreviewOpen] = useState(false);

  const buildLabel = () => {
    if (
      (consent.type === ConsentType.LINK ||
        consent.type === ConsentType.FILE) &&
      consent.url
    ) {
      return (
        <a
          href={consent.url}
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary-600 underline"
        >
          {consent.name}
        </a>
      );
    }

    if (consent.type === ConsentType.TEMPLATE && consent.previewAvailable) {
      return (
        <span>
          {consent.name}{' '}
          <button
            type="button"
            onClick={() => setPreviewOpen(true)}
            className="text-primary-600 underline"
          >
            (podgląd)
          </button>
        </span>
      );
    }

    return consent.name;
  };

  return (
    <>
      <CheckboxInput
        label={buildLabel()}
        register={register}
        error={error}
        required={consent.required}
      />
      {previewOpen && (
        <ConsentPreviewModal
          onClose={() => setPreviewOpen(false)}
          consentId={consent.consentId}
          consentName={consent.name}
          orgSlug={orgSlug}
          tourSlug={tourSlug}
          bookingSpecification={bookingSpecification}
        />
      )}
    </>
  );
};

export default TourConsentCheckbox;
